// Config option kỳ tự tạo khác kỳ chính
export default {
  ThisDay: 20, // Hôm nay
  ThisWeek: 30, // Tuần này
  FirstWeekToPresent: 31, // Đầu tuần đến hiện tại
  ThisMonth: 45, // Tháng này
  FirstMonthToPresent: 46, // Đầu tháng đến hiện tại
  ThisQuarter: 60, // Quý này
  FirstQuarterToPresent: 61, // Đầu quý đến hiện tại
  ThisYear: 500, // Năm nay
  FirstYearToPresent: 501, // Đầu năm đến hiện tại

  January: 1, // tháng 1
  February: 2, // tháng 2
  March: 3, // tháng 3
  April: 4, // tháng 4
  May: 5, // tháng 5
  June: 6, // tháng 6
  July: 7, // tháng 7
  August: 8, // tháng 8
  September: 9, // tháng 9
  October: 10, // tháng 10
  November: 11, // tháng 11
  December: 12, // tháng 12

  FiscalI: 100, // Quý I
  FiscalII: 200, // Quý II
  FiscalIII: 300, // Quý III
  FiscalIV: 400, // Quý IV

  LastWeek: 35, // Tuần trước
  LastMonth: 50, // Tháng trước
  LastQuarter: 65, // Quý trước
  LastYear: 80, // Năm trước
  NextWeek: 40, // Tuần sau
  Next4Week: 151, // Bốn tuần sau
  NextMonth: 55, // Tháng sau
  NextQuarter: 66, // Quý sau
  NextYear: 90, // Năm sau

  Custom: 999, // Tùy chọn
};
